<script lang="ts">
  /**
   * The public site is the planning map and nothing else. `FlightPlanning.svelte` is imported from
   * drone-player rather than copied, so the filters, tooltips, search, Direct/Effective merge and
   * 3D terrain here are the same code that ships there — fixed once, fixed in both.
   *
   * The archive half of that component (my flights, my photos, the media filters) reaches for
   * `/api/flights`, which does not exist on this origin. It already fails closed: the fetch is
   * wrapped and the arrays stay empty, so the flight overlay and its filter section simply never
   * populate. That is why this can be a straight mount rather than a fork.
   */
  import FlightPlanning from '$dp/components/FlightPlanning.svelte';
  import Advisory from './Advisory.svelte';
  import { i18n } from '$dp/lib/i18n.svelte.ts';
  import type { PlanningDataStatus } from '$dp/lib/planning/status.ts';

  // How old the airspace data is, reported by the map and rendered by the advisory bar above it.
  // The bar used to declare a `bakedAt` prop that was never passed, so the freshness stamp above
  // the fold was dead markup — and the only live one sat in a panel that starts collapsed on any
  // screen under 700px, which is most of this site's traffic.
  let status = $state<PlanningDataStatus | null>(null);

  // A Turkish site, in Turkish. This also fixes a real rendering bug rather than a preference: the
  // page declares lang="tr", and CSS `text-transform: uppercase` applies Turkish casing rules under
  // it — so the English section headings came out as "VİEW", "TERRAİN", "MEDİA FİLTERS", because a
  // dotless-i language uppercases "i" to "İ". Turkish labels under a Turkish lang tag are correct
  // on both counts.
  i18n.lang = 'tr';
</script>

<Advisory {status} />

<div class="map-host">
  <!-- What this deployment genuinely has. Not styling: the archive is a local-disk feature that
       cannot exist on a public origin, and weather is deferred until there is a paid Open-Meteo
       plan, so their controls are absent rather than dimmed. -->
  <FlightPlanning
    features={{ archive: false, weather: false, assessment: false, host: false }}
    onDataStatus={(s) => (status = s)}
  />
</div>
